import React from 'react';

function CampaignIcon({ fill, className }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M12.5 18.9582H7.49996C2.97496 18.9582 1.04163 17.0248 1.04163 12.4998V7.49984C1.04163 2.97484 2.97496 1.0415 7.49996 1.0415H12.5C17.025 1.0415 18.9583 2.97484 18.9583 7.49984V12.4998C18.9583 17.0248 17.025 18.9582 12.5 18.9582ZM7.49996 2.2915C3.65829 2.2915 2.29163 3.65817 2.29163 7.49984V12.4998C2.29163 16.3415 3.65829 17.7082 7.49996 17.7082H12.5C16.3416 17.7082 17.7083 16.3415 17.7083 12.4998V7.49984C17.7083 3.65817 16.3416 2.2915 12.5 2.2915H7.49996Z"
        fill={`${fill}`}
      />
      <path
        d="M11.4667 14.7918H8.52499C7.60833 14.7918 6.88332 14.3418 6.47499 13.5252L5.73333 12.0335C5.55833 11.6752 5.19999 11.4585 4.79999 11.4585H1.65833C1.31666 11.4585 1.03333 11.1752 1.03333 10.8335C1.03333 10.4918 1.32499 10.2085 1.66666 10.2085H4.79999C5.67499 10.2085 6.45833 10.6918 6.84999 11.4752L7.59166 12.9668C7.78332 13.3502 8.09166 13.5418 8.52499 13.5418H11.4667C11.8667 13.5418 12.225 13.3252 12.4 12.9668L13.1417 11.4752C13.5333 10.6918 14.3167 10.2085 15.1917 10.2085H18.3083C18.65 10.2085 18.9333 10.4918 18.9333 10.8335C18.9333 11.1752 18.65 11.4585 18.3083 11.4585H15.1917C14.7917 11.4585 14.4333 11.6752 14.2583 12.0335L13.5167 13.5252C13.125 14.3085 12.3417 14.7918 11.4667 14.7918Z"
        fill={`${fill}`}
      />
      <path
        d="M11.3916 6.4585H8.61661C8.26661 6.4585 7.98328 6.17516 7.98328 5.8335C7.98328 5.49183 8.26661 5.2085 8.60828 5.2085H11.3833C11.7249 5.2085 12.0083 5.49183 12.0083 5.8335C12.0083 6.17516 11.7333 6.4585 11.3916 6.4585Z"
        fill={`${fill}`}
      />
      <path
        d="M12.0833 8.9585H7.91663C7.57496 8.9585 7.29163 8.67516 7.29163 8.3335C7.29163 7.99183 7.57496 7.7085 7.91663 7.7085H12.0833C12.425 7.7085 12.7083 7.99183 12.7083 8.3335C12.7083 8.67516 12.425 8.9585 12.0833 8.9585Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default CampaignIcon;
